<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-toolbar dark :color="titleColor" dense>
        <v-icon left v-if="options.icon">{{ options.icon }}</v-icon>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4"><p v-html="message"></p></v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <template v-if="options.buttons">
          <template v-for="(item, i) in options.buttons">
            <v-btn v-if="item.isCancel" :key="i" color="primary" text @click.native="cancel">{{ item.text }}</v-btn>
            <v-btn v-else :key="i" color="primary" text @click.native="buttonClick(item)">{{ item.text }}</v-btn>
          </template>
        </template>
        <template v-else>
          <v-btn color="primary" text @click.native="cancel">{{ options.noText }}</v-btn>
          <v-btn color="primary" text @click.native="agree">{{ options.yesText }}</v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    options: {
      warning: false,
      width: 290,
      zIndex: 200,
      noText: 'No',
      yesText: 'Yes',
      icon: null,
      buttons: null
    },
    defaults: {
      warning: false,
      width: 290,
      zIndex: 200,
      noText: 'No',
      yesText: 'Yes',
      icon: null,
      buttons: null
    }
  }),
  computed: {
    titleColor() {
      if (this.options.warning) {
        return 'warning'
      } else {
        return 'secondary'
      }
    }
  },
  methods: {
    open(title, message, options) {
      this.reset()
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    reset() {
      Object.assign(this.options, this.defaults)
    },
    agree() {
      this.resolve(true)
      this.dialog = false
    },
    buttonClick(item) {
      this.resolve(item.value)
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
